import i18n from '../i18n'
import { clock } from './clock'

/**
 * The practice screen's recording rules (design page 6, `practice`;
 * P-core-2 of the go-live plan): the live waveform is measured, not drawn
 * — a level per window from the microphone's own samples, the newest at
 * the end of a strip of `LIVE_BARS`, so what the learner sees moves with
 * what the microphone hears.
 */

const t = (key, options) => i18n.t(key, { ns: 'lesson', ...options })

/** The design's strip: 46 bars, 40px tall, a 4px stub for silence. */
export const LIVE_BARS = 46
export const LIVE_BAR_MAX_PX = 40
export const LIVE_BAR_MIN_PX = 4

/** One bar per this many milliseconds: a render quantum (~3 ms) is far too fine to draw. */
export const LEVEL_WINDOW_MS = 60

/** Speech at a normal distance has an RMS of roughly 0.05–0.3; this gain puts that in the strip's range. */
const GAIN = 3.5

/** Root mean square of a run of samples — the loudness of that window. */
export function rmsOf(samples) {
  if (!samples || samples.length === 0) return 0
  let sum = 0
  for (let i = 0; i < samples.length; i++) sum += samples[i] * samples[i]
  return Math.sqrt(sum / samples.length)
}

/** A bar's fill, 0..1, from a window's RMS. */
export function levelOf(rms) {
  return Math.min(1, Math.max(0, rms * GAIN))
}

/** The strip keeps its last `cap` levels: the newest at the end, the oldest dropped once full. */
export function pushLevel(levels, level, cap = LIVE_BARS) {
  const next = levels.length >= cap ? levels.slice(levels.length - cap + 1) : levels.slice()
  next.push(level)
  return next
}

export function barHeight(level) {
  return Math.round(LIVE_BAR_MIN_PX + Math.min(1, Math.max(0, level)) * (LIVE_BAR_MAX_PX - LIVE_BAR_MIN_PX))
}

/** «ضبط شد — 0:14»: the chip after a take, its length as a Latin time code. */
export function recordedChip(seconds) {
  return t('recordedChip', { time: clock(seconds) })
}
